import React from 'react'
import { Redirect, NavLink } from "react-router-dom"
import { Alert } from 'react-bootstrap'
import { TextField } from '@mui/material'

import Constants from '../../config.js'
import { UserContext } from "../../Contexts/UserContext/UserContext.js"
import { getLog } from '../../helpers/helpers.js'
import { ButtonPrimary, ButtonPrimaryOutlined } from '../../components/Buttons.js'
import { Loader } from '../../components/Loader.js'

import '../../resources/css/restore_wallet.css'


class Wallet_Unlock extends React.Component {

    static contextType = UserContext

    constructor(props) {
        super(props)
        this.classname = "Wallet_Unlock: "

        this.state = {
            password: "",
            redirect: false,
            error: "",
            loading: false,
        }

        this.handleChange_password = this.handleChange_password.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.handleUnlock = this.handleUnlock.bind(this)
    }


    handleChange_password(event) {
        this.setState({ password: event.target.value, error: "" })
    }


    handleKeyDown(e) {
        if (e.key === 'Enter') {
            this.handleUnlock()
        }
    }


    async handleUnlock(event) {
        if (event) event.preventDefault()
        const log = getLog(this.classname + "handleUnlock():")

        if (!this.state.password) {
            this.setState({ error: "Please enter your password." })
            return
        }

        this.setState({ loading: true, error: "" })

        // small delay to let UI update
        await new Promise(resolve => setTimeout(resolve, 200))

        try {
            const success = await this.context.unlock_wallet_from_password(this.state.password)
            if (success) {
                log("unlock successful, redirecting to /wallet")
                this.setState({ redirect: true })
            } else {
                this.setState({
                    loading: false,
                    error: Constants.WALLET_UNLOCK_WRONG_PASSWORD,
                })
            }
        } catch (err) {
            log("unlock error:", err)
            this.setState({
                loading: false,
                error: Constants.WALLET_UNLOCK_WRONG_PASSWORD,
            })
        }
    }


    render() {
        const log = getLog(this.classname + "render():")

        if (this.state.redirect === true) {
            return (
                <Redirect to="/wallet" push />
            )
        }

        // If a real (non-mock) wallet is already loaded, redirect to /wallet.
        // The AppContent route guard would catch this too, but we check here
        // as defense-in-depth in case this component is mounted directly (e.g.
        // by Display_Wallet's awaiting_unlock redirect). A mock wallet does
        // NOT trigger this guard.
        if (this.context.mnemonic && this.context.isMockWallet !== true) {
            log("real wallet already loaded, redirecting to /wallet")
            return (
                <Redirect to="/wallet" push />
            )
        }

        // if not awaiting unlock, redirect to select_wallet.
        // BUT: skip this guard while we're in the middle of unlocking (loading=true)
        // because unlock_wallet_from_password() clears awaiting_unlock before
        // this component sets redirect=true, which would otherwise race and
        // send the user to /select_wallet instead of /wallet.
        if (!this.context.awaiting_unlock && !this.state.loading) {
            log("not awaiting unlock, redirecting to /select_wallet")
            return (
                <Redirect to="/select_wallet" push />
            )
        }

        const unlockInfo = this.context.pending_unlock_info || {}
        const walletname = unlockInfo.walletname || ""
        const address_owner = unlockInfo.address_owner || ""

        return (
            <div className="mode-selection-style">
                <h2>
                    <br />
                    {Constants.WALLET_UNLOCK_TITLE}
                </h2>
                <br />

                <div style={{ maxWidth: "500px", margin: "0 auto", textAlign: "center" }}>
                    <p className="main-text-page">
                        {Constants.WALLET_UNLOCK_INFO}
                    </p>
                    <br />

                    {walletname ?
                        <div style={{ marginBottom: "1em" }}>
                            <div className="badge badge-light"
                                style={{ padding: "0.8em", fontSize: "18px", wordBreak: "break-all" }}>
                                {walletname}
                            </div>
                            {/* {address_owner ?
                                <div style={{ color: "silver", fontSize: "13px", marginTop: "0.3em" }}>
                                    {address_owner}
                                </div>
                                : null} */}
                        </div>
                        : null}

                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            type="password"
                            value={this.state.password}
                            onChange={this.handleChange_password}
                            onKeyDown={this.handleKeyDown}
                            label={<span>Password</span>}
                            style={{ width: "350px" }}
                            error={!!this.state.error}
                            helperText={this.state.error || ""}
                        />
                    </div>
                    <br />

                    {this.state.loading ?
                        <div style={{ textAlign: "center" }}>
                            <Loader small />
                        </div>
                        : null}
                </div>

                <br />

                <div className="bottom-buttons">
                    <div className="return-button">
                        <NavLink className="return-logo" to="/select_wallet">
                            <ButtonPrimaryOutlined>
                                {Constants.WALLET_UNLOCK_BACK}
                            </ButtonPrimaryOutlined>
                        </NavLink>
                    </div>
                    <div className="next-button">
                        <ButtonPrimary
                            onClick={this.handleUnlock}
                            disabled={this.state.loading || !this.state.password}
                            style={{
                                pointerEvents: (this.state.loading || !this.state.password) ? "none" : "auto",
                                backgroundColor: (this.state.loading || !this.state.password) ? "gray" : "",
                            }}
                        >
                            Unlock
                        </ButtonPrimary>
                    </div>
                </div>

                <div style={{ height: "40vh" }}>&nbsp;</div>
            </div>
        )
    }
}

export default Wallet_Unlock
